import React, { useCallback, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../redux/store';
import { EmptyTable } from '../../EmptyTable';
import { Preloader } from '../../../Client/ui/Preloader';
import { AssignmentRule } from './AssignmentRule';

import { DirectoryPage } from '../DirectoryPage';

import {
    getRulesSelector,
    getIsLoadingSelector,
    getIdToDeleteSelector,
    getErrorsSelector,
    getStatusSelector,
} from '../../../../redux/assignmentRules/selectors';
import { deleteRule, getRules } from '../../../../redux/assignmentRules/asyncThunks';

const housesInfo = {
    path: 'create',
    title: 'Правила назначения',
    text: 'правило',
};

const housesHeadings = ['Категория', 'Департамент', 'Действия'];

export const AssignmentRules: React.FC = () => {
    const dispatch = useAppDispatch();
    const rules = useSelector(getRulesSelector);
    const isLoading = useSelector(getIsLoadingSelector);
    const idToDelete = useSelector(getIdToDeleteSelector);
    const errors = useSelector(getErrorsSelector);
    const status = useSelector(getStatusSelector);

    useLayoutEffect(() => {
        dispatch(getRules());
    }, []);

    const modalHandler = useCallback(() => {
        dispatch(deleteRule(idToDelete));
    }, [idToDelete]);

    return (
        <DirectoryPage
            headings={housesHeadings}
            info={housesInfo}
            modalHandler={modalHandler}
            errors={errors}
            status={status}
        >
            {isLoading
                ? <Preloader />
                : (
                    <ul>
                        {rules.length > 0
                            ? rules.map((i) => <AssignmentRule key={i.id} rule={i} />)
                            : <EmptyTable />}
                    </ul>
                )}
        </DirectoryPage>

    );
};
